<template>
  <div class="app-loader">
    <img class="app-loader__logo" src="../../assets/icons/logo.svg" alt="M Leuven logo" />
    <a class="app-loader__reload button" href="/">Opnieuw laden</a>
  </div>
</template>

<script src="./AppLoader.js"></script>
